"use strict";

function helper(Handlebars) {
  /**
   * Comparison helper
   *
   * @param  {any}    left     First value to compare
   * @param  {String} operator The operator, must be between quotes.  (==, ===, !=, !==, <, >, <=, >=, typeof)
   *                           If the operator is not sent in, than an "===" comparison is the default comparison
   * @param  {any}    right    Second value to compare
   * @param  {Object} options  'option' object sent by handlebars
   * @return {String}          Formatted HTML
   *
   * @example:
   *   {{#compare x 10}}
   *     The value of x is 10
   *   {{/compare}}
   *
   *   {{#compare x "<" y}}
   *     The value of x is less than y
   *   {{/compare}}
   *
   *   {{#compare x ">=" 10}}
   *     The value of x is greater or equal than 10
   *     {{else}}
   *     The value of x is lower than 10
   *   {{/compare}}
   *
   * @credit Copied from "compare" at https://github.com/assemble/handlebars-helpers/blob/master/lib/helpers/helpers-comparisons.js
   */
  function compare(left, operator, right, options) {
    if (arguments.length < 3) {
      throw new Error('Handlebars Helper "compare" needs 2 parameters');
    }

    /* eslint-disable no-param-reassign */
    if (options === undefined) {
      options = right;
      right = operator;
      operator = '===';
    }
    /* eslint-disable no-param-reassign */

    var operators = {
      '===': function _(l, r) {
        return l === r;
      },
      '!==': function _(l, r) {
        return l !== r;
      },
      '<': function _(l, r) {
        return l < r;
      },
      '>': function _(l, r) {
        return l > r;
      },
      /* eslint eqeqeq: "off" */
      '==': function _(l, r) {
        return l == r;
      }
      // TODO: enable and implement tests for this cases
      // '!=':     function(l, r) {return l != r; },
      // '<=':     function(l, r) {return l <= r; },
      // '>=':     function(l, r) {return l >= r; },
      // 'typeof': function(l, r) {return typeof l == r; }
    };

    if (!operators[operator]) {
      throw new Error("Handlebars Helper \"compare\" doesn't know the operator ".concat(operator));
    }
    var result = operators[operator](left, right);
    if (result) {
      return options.fn(this);
    }
    return options.inverse(this);
  }
  Handlebars.registerHelper('compare', compare);
  return compare;
}
module.exports = helper;
